(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(global, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 15);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoveoBase = void 0;
var React = __importStar(__webpack_require__(1));
var react_1 = __webpack_require__(1);
var JssUtils_1 = __webpack_require__(4);
var CoveoBase = /** @class */ (function (_super) {
    __extends(CoveoBase, _super);
    function CoveoBase(props) {
        var _this = _super.call(this, props) || this;
        _this.hiveAttributes = {};
        _this.attributes = {};
        _this.experienceEditorTitle = '';
        _this.rawPropertiesToDataAttributes = function (rawProperties) {
            var attributes = Object.keys(rawProperties)
                .filter(function (key) { return key !== 'data-id'; })
                .reduce(function (attributes, key) {
                var _a;
                return (__assign(__assign({}, attributes), (_a = {}, _a["data-" + key] = _this.valueToString(rawProperties[key]), _a)));
            }, {});
            if (rawProperties && rawProperties['data-id']) {
                attributes['data-id'] = rawProperties['data-id'];
            }
            return attributes;
        };
        _this.tagName = 'div';
        var fields = props.fields;
        if (fields && fields.rawProperties && fields.rawProperties.value) {
            _this.hiveAttributes = _this.rawPropertiesToDataAttributes(fields.rawProperties.value);
        }
        _this._reference = React.createRef();
        return _this;
    }
    Object.defineProperty(CoveoBase.prototype, "id", {
        get: function () {
            return this.hiveAttributes.id || (this.props.fields && this.props.fields.id && this.props.fields.id.value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CoveoBase.prototype, "cssClass", {
        get: function () {
            return (this.hiveAttributes.cssClass ||
                (this.props.fields && this.props.fields.cssClass && this.props.fields.cssClass.value));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CoveoBase.prototype, "isEditingInPageEditor", {
        get: function () {
            return JssUtils_1.JssUtils.isEditingInPageEditor();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CoveoBase.prototype, "reference", {
        get: function () {
            return this._reference;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CoveoBase.prototype, "model", {
        // Ensures one level of safe access. Any key in here could be empty.
        get: function () {
            return (this.props.fields || {});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CoveoBase.prototype, "properties", {
        // Ensures one level of safe access. Any key in here could be empty.
        get: function () {
            return ((this.props.fields && this.props.fields.properties && this.props.fields.properties.value) ||
                {});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CoveoBase.prototype, "rawProperties", {
        // Ensures one level of safe access. Any key in here could be empty.
        get: function () {
            return ((this.props.fields && this.props.fields.rawProperties && this.props.fields.rawProperties.value) ||
                {});
        },
        enumerable: false,
        configurable: true
    });
    CoveoBase.prototype.valueToString = function (obj) {
        return typeof obj === 'string' ? obj : JSON.stringify(obj);
    };
    CoveoBase.prototype.renderChildren = function () {
        return null;
    };
    CoveoBase.prototype.renderExperienceEditorTitle = function () {
        return !!this.experienceEditorTitle && this.isEditingInPageEditor ? (React.createElement("span", null, this.experienceEditorTitle)) : null;
    };
    CoveoBase.prototype.e2eId = function () {
        return this.id ? { 'data-e2e-id': "coveo-" + this.id } : null;
    };
    CoveoBase.prototype.render = function () {
        return (React.createElement(this.tagName, __assign({}, this.attributes, this.hiveAttributes, { id: this.id || null, className: (this.hiveComponentClass || '') + " " + (this.cssClass || '') }, this.e2eId(), { ref: this._reference }),
            this.renderExperienceEditorTitle(),
            this.renderChildren()));
    };
    return CoveoBase;
}(react_1.Component));
exports.CoveoBase = CoveoBase;
//# sourceMappingURL=CoveoBase.js.map

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("@sitecore-jss/sitecore-jss-react");

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.JssUtils = void 0;
var JssUtils = /** @class */ (function () {
    function JssUtils() {
    }
    JssUtils.getViewName = function () {
        if (JssUtils.isServerSideRendering()) {
            return '';
        }
        var url = window.location.pathname;
        return url.substring(url.lastIndexOf('/') + 1);
    };
    JssUtils.isServerSideRendering = function () {
        return typeof window === 'undefined';
    };
    JssUtils.isEditingInPageEditor = function () {
        return typeof Sitecore !== 'undefined' && Sitecore && Sitecore.PageModes && Sitecore.PageModes.PageEditor;
    };
    return JssUtils;
}());
exports.JssUtils = JssUtils;
//# sourceMappingURL=JssUtils.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.adaptAttributeForScopeToTab = void 0;
exports.adaptAttributeForScopeToTab = function (properties, _a) {
    var hasScopeToTab = _a.hasScopeToTab, scopeToTab = _a.scopeToTab;
    return (__assign(__assign({}, properties), { 'data-sc-scope-to-tab': !!hasScopeToTab && hasScopeToTab.value && !!scopeToTab && !!scopeToTab.value ? scopeToTab.value : null }));
};
//# sourceMappingURL=WithScopeToTab.js.map

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalContent = void 0;
var React = __importStar(__webpack_require__(1));
var CoveoBase_1 = __webpack_require__(2);
var WithScopeToTab_1 = __webpack_require__(5);
var ExternalContent = /** @class */ (function (_super) {
    __extends(ExternalContent, _super);
    function ExternalContent(props) {
        var _this = _super.call(this, props) || this;
        _this.hiveComponentClass = 'CoveoForSitecoreExternalContent';
        _this.tagName = 'span';
        _this.hiveAttributes = WithScopeToTab_1.adaptAttributeForScopeToTab(_this.hiveAttributes, _this.model);
        return _this;
    }
    ExternalContent.prototype.render = function () {
        var _a, _b;
        return (React.createElement(React.Fragment, null,
            this.isEditingInPageEditor && React.createElement("div", null, "External Content"),
            ((_b = (_a = this.model) === null || _a === void 0 ? void 0 : _a.hasExternalContent) === null || _b === void 0 ? void 0 : _b.value) ? _super.prototype.render.call(this) : null));
    };
    return ExternalContent;
}(CoveoBase_1.CoveoBase));
exports.ExternalContent = ExternalContent;
//# sourceMappingURL=ExternalContent.js.map

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryFilter = void 0;
var React = __importStar(__webpack_require__(1));
var CoveoBase_1 = __webpack_require__(2);
var WithScopeToTab_1 = __webpack_require__(5);
var QueryFilter = /** @class */ (function (_super) {
    __extends(QueryFilter, _super);
    function QueryFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.hiveComponentClass = 'CoveoForSitecoreFilterExpression';
        _this.hiveAttributes = WithScopeToTab_1.adaptAttributeForScopeToTab(_this.hiveAttributes, _this.model);
        return _this;
    }
    QueryFilter.prototype.render = function () {
        var _a, _b;
        return (React.createElement(React.Fragment, null,
            this.isEditingInPageEditor && ((_b = (_a = this.model) === null || _a === void 0 ? void 0 : _a.visibleText) === null || _b === void 0 ? void 0 : _b.value) && (React.createElement("div", null, this.model.visibleText.value)),
            this.hasFilterValue()
                ? _super.prototype.render.call(this)
                : console.warn('No filters will be applied to the QueryFilter component')));
    };
    QueryFilter.prototype.hasFilterValue = function () {
        var _a, _b;
        return (_b = (_a = this.model) === null || _a === void 0 ? void 0 : _a.hasFilter) === null || _b === void 0 ? void 0 : _b.value;
    };
    return QueryFilter;
}(CoveoBase_1.CoveoBase));
exports.QueryFilter = QueryFilter;
//# sourceMappingURL=QueryFilter.js.map

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryRanking = void 0;
var React = __importStar(__webpack_require__(1));
var CoveoBase_1 = __webpack_require__(2);
var WithScopeToTab_1 = __webpack_require__(5);
var QueryRanking = /** @class */ (function (_super) {
    __extends(QueryRanking, _super);
    function QueryRanking(props) {
        var _this = _super.call(this, props) || this;
        _this.hiveComponentClass = 'CoveoForSitecoreRankingExpression';
        _this.hiveAttributes = WithScopeToTab_1.adaptAttributeForScopeToTab(_this.hiveAttributes, _this.model);
        return _this;
    }
    QueryRanking.prototype.render = function () {
        var _a, _b, _c, _d;
        return (React.createElement(React.Fragment, null,
            this.isEditingInPageEditor && ((_b = (_a = this.model) === null || _a === void 0 ? void 0 : _a.visibleText) === null || _b === void 0 ? void 0 : _b.value) && (React.createElement("div", null, this.model.visibleText.value)),
            ((_d = (_c = this.model) === null || _c === void 0 ? void 0 : _c.hasRanking) === null || _d === void 0 ? void 0 : _d.value) ? _super.prototype.render.call(this) : null));
    };
    return QueryRanking;
}(CoveoBase_1.CoveoBase));
exports.QueryRanking = QueryRanking;
//# sourceMappingURL=QueryRanking.js.map

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoveoJssEvents = void 0;
var CoveoJssEvents = /** @class */ (function () {
    function CoveoJssEvents() {
    }
    CoveoJssEvents.emit = function (eventName) {
        window.dispatchEvent(new Event(eventName));
    };
    CoveoJssEvents.on = function (eventName, callback) {
        window.addEventListener(eventName, function (e) {
            callback();
        });
    };
    CoveoJssEvents.CoveoResourcesLoaded = 'CoveoResourcesLoaded';
    return CoveoJssEvents;
}());
exports.CoveoJssEvents = CoveoJssEvents;
//# sourceMappingURL=CoveoJssEvents.js.map

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoveoUtils = void 0;
var CoveoUtils = /** @class */ (function () {
    function CoveoUtils() {
    }
    CoveoUtils.isCoveoDefined = function () {
        return typeof Coveo !== 'undefined';
    };
    CoveoUtils.isCoveoForSitecoreDefined = function () {
        return typeof CoveoForSitecore !== 'undefined';
    };
    CoveoUtils.htmlEncode = function (str) {
        return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    };
    return CoveoUtils;
}());
exports.CoveoUtils = CoveoUtils;
//# sourceMappingURL=CoveoUtils.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactResultTemplate = void 0;
var React = __importStar(__webpack_require__(1));
var filtersToDataAttributes = function (filters) {
    return Object.keys(filters || {}).reduce(function (all, name) {
        var _a;
        return __assign(__assign({}, all), (_a = {}, _a["data-field-" + name] = filters[name], _a));
    }, {});
};
exports.ReactResultTemplate = function (_a) {
    var rawTemplate = _a.rawTemplate, attributes = _a.attributes, filters = _a.filters;
    return (React.createElement("script", __assign({ className: 'result-template', type: 'text/x-underscore-template' }, filtersToDataAttributes(filters), attributes, { dangerouslySetInnerHTML: { __html: rawTemplate } })));
};
//# sourceMappingURL=ReactResultTemplate.js.map

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomaticBoosting = void 0;
var CoveoBase_1 = __webpack_require__(2);
var WithScopeToTab_1 = __webpack_require__(5);
var AutomaticBoosting = /** @class */ (function (_super) {
    __extends(AutomaticBoosting, _super);
    function AutomaticBoosting(props) {
        var _this = _super.call(this, props) || this;
        _this.hiveComponentClass = 'CoveoForSitecoreRankingExpression';
        _this.experienceEditorTitle = 'Automatic Boosting';
        _this.hiveAttributes = WithScopeToTab_1.adaptAttributeForScopeToTab(_this.hiveAttributes, _this.model);
        return _this;
    }
    return AutomaticBoosting;
}(CoveoBase_1.CoveoBase));
exports.AutomaticBoosting = AutomaticBoosting;
//# sourceMappingURL=AutomaticBoosting.js.map

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SitecoreInstanceFilter = void 0;
var CoveoBase_1 = __webpack_require__(2);
var SitecoreInstanceFilter = /** @class */ (function (_super) {
    __extends(SitecoreInstanceFilter, _super);
    function SitecoreInstanceFilter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hiveComponentClass = 'CoveoForSitecoreLocalExpression';
        _this.experienceEditorTitle = 'Local Expression Filter';
        return _this;
    }
    return SitecoreInstanceFilter;
}(CoveoBase_1.CoveoBase));
exports.SitecoreInstanceFilter = SitecoreInstanceFilter;
//# sourceMappingURL=SitecoreInstanceFilter.js.map

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = require("react-helmet");

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Analytics_1 = __webpack_require__(16);
Object.defineProperty(exports, "CoveoAnalytics", { enumerable: true, get: function () { return Analytics_1.CoveoForSitecoreAnalytics; } });
var Pager_1 = __webpack_require__(17);
Object.defineProperty(exports, "CoveoPager", { enumerable: true, get: function () { return Pager_1.Pager; } });
var QuerySummary_1 = __webpack_require__(18);
Object.defineProperty(exports, "CoveoQuerySummary", { enumerable: true, get: function () { return QuerySummary_1.QuerySummary; } });
var ResultsPerPage_1 = __webpack_require__(19);
Object.defineProperty(exports, "CoveoResultsPerPage", { enumerable: true, get: function () { return ResultsPerPage_1.ResultsPerPage; } });
var Breadcrumb_1 = __webpack_require__(20);
Object.defineProperty(exports, "CoveoBreadcrumb", { enumerable: true, get: function () { return Breadcrumb_1.Breadcrumb; } });
var DidYouMean_1 = __webpack_require__(21);
Object.defineProperty(exports, "CoveoDidYouMean", { enumerable: true, get: function () { return DidYouMean_1.DidYouMean; } });
var Facet_1 = __webpack_require__(22);
Object.defineProperty(exports, "CoveoFacet", { enumerable: true, get: function () { return Facet_1.Facet; } });
var FacetSlider_1 = __webpack_require__(23);
Object.defineProperty(exports, "CoveoFacetSlider", { enumerable: true, get: function () { return FacetSlider_1.FacetSlider; } });
var ModularFrame_1 = __webpack_require__(24);
Object.defineProperty(exports, "CoveoModularFrame", { enumerable: true, get: function () { return ModularFrame_1.ModularFrame; } });
var ResultList_1 = __webpack_require__(25);
Object.defineProperty(exports, "CoveoResultList", { enumerable: true, get: function () { return ResultList_1.ResultList; } });
var DefaultResultTemplate_1 = __webpack_require__(26);
Object.defineProperty(exports, "CoveoDefaultResultTemplate", { enumerable: true, get: function () { return DefaultResultTemplate_1.DefaultResultTemplate; } });
var ItemResultTemplate_1 = __webpack_require__(27);
Object.defineProperty(exports, "CoveoItemResultTemplate", { enumerable: true, get: function () { return ItemResultTemplate_1.ItemResultTemplate; } });
var ReactResultTemplate_1 = __webpack_require__(11);
Object.defineProperty(exports, "CoveoReactResultTemplate", { enumerable: true, get: function () { return ReactResultTemplate_1.ReactResultTemplate; } });
var AutomaticBoosting_1 = __webpack_require__(12);
Object.defineProperty(exports, "CoveoAutomaticBoosting", { enumerable: true, get: function () { return AutomaticBoosting_1.AutomaticBoosting; } });
var ExternalContent_1 = __webpack_require__(6);
Object.defineProperty(exports, "CoveoExternalContent", { enumerable: true, get: function () { return ExternalContent_1.ExternalContent; } });
var QueryFilter_1 = __webpack_require__(7);
Object.defineProperty(exports, "CoveoQueryFilter", { enumerable: true, get: function () { return QueryFilter_1.QueryFilter; } });
var QueryRanking_1 = __webpack_require__(8);
Object.defineProperty(exports, "CoveoQueryRanking", { enumerable: true, get: function () { return QueryRanking_1.QueryRanking; } });
var SitecoreInstanceFilter_1 = __webpack_require__(13);
Object.defineProperty(exports, "CoveoSitecoreInstanceFilter", { enumerable: true, get: function () { return SitecoreInstanceFilter_1.SitecoreInstanceFilter; } });
var SearchBox_1 = __webpack_require__(28);
Object.defineProperty(exports, "CoveoSearchbox", { enumerable: true, get: function () { return SearchBox_1.Searchbox; } });
var SearchInterface_1 = __webpack_require__(29);
Object.defineProperty(exports, "CoveoSearchInterface", { enumerable: true, get: function () { return SearchInterface_1.SearchInterface; } });
var SearchResources_1 = __webpack_require__(30);
Object.defineProperty(exports, "CoveoSearchResources", { enumerable: true, get: function () { return SearchResources_1.SearchResources; } });
var HostedSearchPage_1 = __webpack_require__(32);
Object.defineProperty(exports, "CoveoHostedSearchPage", { enumerable: true, get: function () { return HostedSearchPage_1.HostedSearchPage; } });
var ExternalComponentsSection_1 = __webpack_require__(36);
Object.defineProperty(exports, "CoveoExternalComponentsSection", { enumerable: true, get: function () { return ExternalComponentsSection_1.ExternalComponentsSection; } });
var FacetsSection_1 = __webpack_require__(37);
Object.defineProperty(exports, "CoveoFacetsSection", { enumerable: true, get: function () { return FacetsSection_1.FacetsSection; } });
var GlobalSearchSection_1 = __webpack_require__(38);
Object.defineProperty(exports, "CoveoGlobalSearchSection", { enumerable: true, get: function () { return GlobalSearchSection_1.GlobalSearchSection; } });
var ResultsHeaderSection_1 = __webpack_require__(39);
Object.defineProperty(exports, "CoveoResultsHeaderSection", { enumerable: true, get: function () { return ResultsHeaderSection_1.ResultsHeaderSection; } });
var ResultsSection_1 = __webpack_require__(40);
Object.defineProperty(exports, "CoveoResultsSection", { enumerable: true, get: function () { return ResultsSection_1.ResultsSection; } });
var ResultsSortsSection_1 = __webpack_require__(41);
Object.defineProperty(exports, "CoveoResultsSortsSection", { enumerable: true, get: function () { return ResultsSortsSection_1.ResultsSortsSection; } });
var ResultsSummarySection_1 = __webpack_require__(42);
Object.defineProperty(exports, "CoveoResultsSummarySection", { enumerable: true, get: function () { return ResultsSummarySection_1.ResultsSummarySection; } });
var SearchSection_1 = __webpack_require__(43);
Object.defineProperty(exports, "CoveoSearchSection", { enumerable: true, get: function () { return SearchSection_1.SearchSection; } });
var TabsSection_1 = __webpack_require__(44);
Object.defineProperty(exports, "CoveoTabsSection", { enumerable: true, get: function () { return TabsSection_1.TabsSection; } });
var Sort_1 = __webpack_require__(45);
Object.defineProperty(exports, "CoveoSort", { enumerable: true, get: function () { return Sort_1.Sort; } });
var Tab_1 = __webpack_require__(46);
Object.defineProperty(exports, "CoveoTab", { enumerable: true, get: function () { return Tab_1.Tab; } });
//# sourceMappingURL=components.js.map

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoveoForSitecoreAnalytics = void 0;
var React = __importStar(__webpack_require__(1));
var CoveoBase_1 = __webpack_require__(2);
var CoveoAnalytics = /** @class */ (function (_super) {
    __extends(CoveoAnalytics, _super);
    function CoveoAnalytics() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hiveComponentClass = 'CoveoAnalytics';
        return _this;
    }
    return CoveoAnalytics;
}(CoveoBase_1.CoveoBase));
var CoveoForSitecoreAnalytics = /** @class */ (function (_super) {
    __extends(CoveoForSitecoreAnalytics, _super);
    function CoveoForSitecoreAnalytics(props) {
        var _this = _super.call(this, props) || this;
        _this.hiveComponentClass = 'CoveoForSitecoreAnalytics';
        _this.experienceEditorTitle = 'Coveo For Sitecore Analytics';
        if (_this.isEditingInPageEditor) {
            console.warn('Analytics are not logged if you are in Edit or Preview mode. Please visit the published page to log analytics.');
        }
        return _this;
    }
    CoveoForSitecoreAnalytics.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            _super.prototype.render.call(this),
            this.model.subModels && (React.createElement(React.Fragment, null,
                React.createElement(CoveoAnalytics, { fields: this.model.subModels.value.analytics })))));
    };
    return CoveoForSitecoreAnalytics;
}(CoveoBase_1.CoveoBase));
exports.CoveoForSitecoreAnalytics = CoveoForSitecoreAnalytics;
//# sourceMappingURL=Analytics.js.map

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pager = void 0;
var CoveoBase_1 = __webpack_require__(2);
var Pager = /** @class */ (function (_super) {
    __extends(Pager, _super);
    function Pager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hiveComponentClass = 'CoveoPager';
        _this.experienceEditorTitle = 'Coveo Pager';
        return _this;
    }
    return Pager;
}(CoveoBase_1.CoveoBase));
exports.Pager = Pager;
//# sourceMappingURL=Pager.js.map

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuerySummary = void 0;
var CoveoBase_1 = __webpack_require__(2);
var QuerySummary = /** @class */ (function (_super) {
    __extends(QuerySummary, _super);
    function QuerySummary(props) {
        var _this = _super.call(this, props) || this;
        _this.hiveComponentClass = 'CoveoQuerySummary';
        _this.tagName = 'span';
        return _this;
    }
    return QuerySummary;
}(CoveoBase_1.CoveoBase));
exports.QuerySummary = QuerySummary;
//# sourceMappingURL=QuerySummary.js.map

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultsPerPage = void 0;
var CoveoBase_1 = __webpack_require__(2);
var ResultsPerPage = /** @class */ (function (_super) {
    __extends(ResultsPerPage, _super);
    function ResultsPerPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hiveComponentClass = 'CoveoResultsPerPage';
        return _this;
    }
    return ResultsPerPage;
}(CoveoBase_1.CoveoBase));
exports.ResultsPerPage = ResultsPerPage;
//# sourceMappingURL=ResultsPerPage.js.map

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumb = void 0;
var CoveoBase_1 = __webpack_require__(2);
var Breadcrumb = /** @class */ (function (_super) {
    __extends(Breadcrumb, _super);
    function Breadcrumb() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hiveComponentClass = 'CoveoBreadcrumb';
        _this.experienceEditorTitle = 'Coveo Breadcrumb';
        return _this;
    }
    return Breadcrumb;
}(CoveoBase_1.CoveoBase));
exports.Breadcrumb = Breadcrumb;
//# sourceMappingURL=Breadcrumb.js.map

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DidYouMean = void 0;
var CoveoBase_1 = __webpack_require__(2);
var DidYouMean = /** @class */ (function (_super) {
    __extends(DidYouMean, _super);
    function DidYouMean() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hiveComponentClass = 'CoveoDidYouMean';
        _this.experienceEditorTitle = 'Coveo Did You Mean';
        return _this;
    }
    return DidYouMean;
}(CoveoBase_1.CoveoBase));
exports.DidYouMean = DidYouMean;
//# sourceMappingURL=DidYouMean.js.map

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Facet = void 0;
var CoveoBase_1 = __webpack_require__(2);
var Facet = /** @class */ (function (_super) {
    __extends(Facet, _super);
    function Facet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Facet;
}(CoveoBase_1.CoveoBase));
exports.Facet = Facet;
//# sourceMappingURL=Facet.js.map

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacetSlider = void 0;
var CoveoBase_1 = __webpack_require__(2);
var FacetSlider = /** @class */ (function (_super) {
    __extends(FacetSlider, _super);
    function FacetSlider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FacetSlider;
}(CoveoBase_1.CoveoBase));
exports.FacetSlider = FacetSlider;
//# sourceMappingURL=FacetSlider.js.map

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModularFrame = void 0;
var sitecore_jss_react_1 = __webpack_require__(3);
var React = __importStar(__webpack_require__(1));
exports.ModularFrame = function (_a) {
    var rendering = _a.rendering;
    return (React.createElement("div", null,
        React.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-header-section', rendering: rendering }),
        React.createElement("div", { className: 'coveo-main-section' },
            React.createElement("div", { className: 'coveo-header' },
                React.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-header', rendering: rendering })),
            React.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-main-section', rendering: rendering }),
            React.createElement("div", { className: 'coveo-footer' },
                React.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-footer', rendering: rendering }))),
        React.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-footer-section', rendering: rendering })));
};
//# sourceMappingURL=ModularFrame.js.map

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultList = void 0;
var sitecore_jss_react_1 = __webpack_require__(3);
var react_1 = __importDefault(__webpack_require__(1));
var CoveoBase_1 = __webpack_require__(2);
var ResultList = /** @class */ (function (_super) {
    __extends(ResultList, _super);
    function ResultList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hiveComponentClass = 'CoveoResultList';
        _this.experienceEditorTitle = 'Coveo Result List';
        return _this;
    }
    ResultList.prototype.renderChildren = function () {
        return react_1.default.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-result-templates', rendering: this.props.rendering });
    };
    return ResultList;
}(CoveoBase_1.CoveoBase));
exports.ResultList = ResultList;
//# sourceMappingURL=ResultList.js.map

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultResultTemplate = void 0;
var React = __importStar(__webpack_require__(1));
var ReactResultTemplate_1 = __webpack_require__(11);
var rawTemplate = "<div class=\"coveo-result-frame coveoforsitecore-template\">\n    <div class=\"coveo-result-row\">\n        <div class=\"coveo-result-cell coveo-quick-view-container\">\n            <span class=\"CoveoIcon\"></span>\n            <% if (hasHtmlVersion) { %>\n                <div class='CoveoQuickview'\n                     data-fixed='true'></div>\n            <% } %>\n        </div>\n\n        <div class=\"coveo-result-cell coveoforsitecore-information-section\">\n            <div class=\"coveo-result-row\">\n                <div class=\"coveo-result-cell\">\n                    <div class='coveo-title'>\n                        <% if (coveoFieldValue(\"HasLayout\") === \"1\" || raw.source !== currentSourceName()) { %>\n                            <a class='CoveoResultLink'><%= title ? highlight(title, titleHighlights) : clickUri %></a>\n                        <% } else { %>\n                            <span class='CoveoResultTitle'><%= title ? highlight(title, titleHighlights) : '' %></span>\n                        <% } %>\n                    </div>\n                </div>\n\n                <div class=\"coveo-result-cell coveoforsitecore-time-cell\">\n                    <% if (coveoFieldValue(\"created\") === coveoFieldValue(\"updated\")) { %>\n                        <div title='<%= translateLabel(\"Creation Time\") %>'><%- dateTime(raw.date) %></div>\n                    <% } else { %>\n                        <div title='<%= translateLabel(\"Last Time Modified\") %>'><%- dateTime(raw.date) %></div>\n                    <% } %>\n                </div>\n            </div>\n\n            <div class=\"coveo-result-row\">\n                <div class=\"coveo-result-cell\">\n                    <span class=\"CoveoExcerpt\"></span>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"coveo-result-row\">\n        <div class=\"coveo-result-cell coveoforsitecore-details-section\">\n            <table class=\"CoveoFieldTable\">\n                <tbody>\n                    <tr data-field='<%= coveoFieldName(\"@_templatename\") %>' data-caption='<%= translateLabel(\"Template\") %>' />\n                    <% if (coveoFieldValue(\"created\") === coveoFieldValue(\"updated\")) { %>\n                        <tr data-field='<%= coveoFieldName(\"@parsedcreatedby\") %>' data-caption='<%= translateLabel(\"Created By\") %>' />\n                    <% } else { %>\n                        <tr data-field='<%= coveoFieldName(\"@parsedcreatedby\") %>' data-caption='<%= translateLabel(\"Created By\") %>' />\n                        <tr data-field='<%= coveoFieldName(\"@created\") %>' data-caption='<%= translateLabel(\"Created\") %>' data-helper='dateTime' />\n                        <tr data-field='<%= coveoFieldName(\"@parsedupdatedby\") %>' data-caption='<%= translateLabel(\"Updated By\") %>' />\n                    <% } %>\n                    <tr data-field='<%= coveoFieldName(\"@parsedlanguage\") %>' data-caption='<%= translateLabel(\"Language\") %>' />\n                    <tr>\n                        <th class='CoveoCaption'><%= translateLabel(\"Uniform resource identifier\") %></th>\n                        <td class='CoveoClickableUri'>\n                            <a class='CoveoResultLink' href=\"<%= clickUri%>\"><%= clickUri%></a>\n                        </td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n</div>\n";
exports.DefaultResultTemplate = function () { return React.createElement(ReactResultTemplate_1.ReactResultTemplate, { rawTemplate: rawTemplate }); };
//# sourceMappingURL=DefaultResultTemplate.js.map

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemResultTemplate = void 0;
var CoveoBase_1 = __webpack_require__(2);
var ItemResultTemplate = /** @class */ (function (_super) {
    __extends(ItemResultTemplate, _super);
    function ItemResultTemplate(props) {
        var _this = _super.call(this, props) || this;
        _this.tagName = 'script';
        _this.attributes = {
            'data-e2e-id': 'coveo-itemresulttemplate',
            type: 'text/x-underscore-template',
        };
        _this.hiveAttributes = {
            cssClass: 'result-template',
        };
        return _this;
    }
    ItemResultTemplate.prototype.renderChildren = function () {
        return this.properties.script;
    };
    return ItemResultTemplate;
}(CoveoBase_1.CoveoBase));
exports.ItemResultTemplate = ItemResultTemplate;
//# sourceMappingURL=ItemResultTemplate.js.map

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Searchbox = void 0;
var sitecore_jss_react_1 = __webpack_require__(3);
var react_1 = __importDefault(__webpack_require__(1));
var CoveoBase_1 = __webpack_require__(2);
var JssUtils_1 = __webpack_require__(4);
var CoveoJssEvents_1 = __webpack_require__(9);
var CoveoUtils_1 = __webpack_require__(10);
var Searchbox = /** @class */ (function (_super) {
    __extends(Searchbox, _super);
    function Searchbox(props) {
        var _this = _super.call(this, props) || this;
        _this.hiveComponentClass = 'CoveoSearchbox';
        _this.containerId = _this.id + '_container';
        if (!JssUtils_1.JssUtils.isServerSideRendering()) {
            CoveoJssEvents_1.CoveoJssEvents.on(CoveoJssEvents_1.CoveoJssEvents.CoveoResourcesLoaded, function () {
                _this.initialize();
            });
        }
        return _this;
    }
    Object.defineProperty(Searchbox.prototype, "searchPageUri", {
        get: function () {
            return this.properties.searchPageUri;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Searchbox.prototype, "searchInterfaceRawProperties", {
        get: function () {
            var searchInterfaceSubModel = this.properties.searchInterfaceSubModel;
            return ((searchInterfaceSubModel && this.rawPropertiesToDataAttributes(searchInterfaceSubModel.rawProperties)) || {});
        },
        enumerable: false,
        configurable: true
    });
    Searchbox.prototype.initialize = function () {
        var _this = this;
        document.addEventListener('CoveoSearchEndpointInitialized', function () {
            if (CoveoUtils_1.CoveoUtils.isCoveoForSitecoreDefined()) {
                CoveoForSitecore.initSearchboxIfStandalone(_this.reference.current, _this.searchPageUri);
            }
        });
    };
    Searchbox.prototype.renderChildren = function () {
        var configureSearchHubProps = {
            'data-sc-search-hub': this.properties.searchHub || undefined,
        };
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: 'CoveoForSitecoreExpressions' }),
            react_1.default.createElement("div", __assign({ className: 'CoveoForSitecoreConfigureSearchHub' }, configureSearchHubProps))));
    };
    Searchbox.prototype.render = function () {
        return (react_1.default.createElement("div", __assign({ id: this.containerId }, this.searchInterfaceRawProperties, { className: "coveo-for-sitecore-search-box-container" }),
            _super.prototype.render.call(this),
            react_1.default.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-searchbox-components', rendering: this.props.rendering })));
    };
    return Searchbox;
}(CoveoBase_1.CoveoBase));
exports.Searchbox = Searchbox;
//# sourceMappingURL=SearchBox.js.map

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInterface = void 0;
var sitecore_jss_react_1 = __webpack_require__(3);
var React = __importStar(__webpack_require__(1));
var CoveoJssEvents_1 = __webpack_require__(9);
var CoveoUtils_1 = __webpack_require__(10);
var JssUtils_1 = __webpack_require__(4);
var CoveoBase_1 = __webpack_require__(2);
var AutomaticBoosting_1 = __webpack_require__(12);
var QueryFilter_1 = __webpack_require__(7);
var QueryRanking_1 = __webpack_require__(8);
var ExternalContent_1 = __webpack_require__(6);
var SitecoreInstanceFilter_1 = __webpack_require__(13);
var SearchInterface = /** @class */ (function (_super) {
    __extends(SearchInterface, _super);
    function SearchInterface(props) {
        var _this = _super.call(this, props) || this;
        _this.hiveComponentClass = 'CoveoSearchInterface';
        if (!JssUtils_1.JssUtils.isServerSideRendering()) {
            CoveoJssEvents_1.CoveoJssEvents.on(CoveoJssEvents_1.CoveoJssEvents.CoveoResourcesLoaded, function (e) {
                _this.initialize();
            });
        }
        return _this;
    }
    SearchInterface.prototype.initialize = function () {
        var _this = this;
        var searchInterface = this.reference.current;
        document.addEventListener('CoveoSearchEndpointInitialized', function () {
            if (CoveoUtils_1.CoveoUtils.isCoveoForSitecoreDefined()) {
                if (_this.isEditingInPageEditor && CoveoUtils_1.CoveoUtils.isCoveoDefined()) {
                    CoveoForSitecore.initializeSearchInterfaceForExperienceEditor(searchInterface);
                }
                else {
                    CoveoForSitecore.initSearchInterface(searchInterface);
                }
            }
        });
    };
    SearchInterface.prototype.renderExperienceEditorMandatoryComponentTitle = function () {
        return (this.isEditingInPageEditor && (React.createElement(React.Fragment, null,
            React.createElement("div", null, "Mandatory components (Edit the Search Interface properties to configure them)"),
            React.createElement("div", { className: 'CoveoValidateAnalyticsIncluded' }))));
    };
    SearchInterface.prototype.renderChildren = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'coveo-search-interface-mandatory-section' },
                this.renderExperienceEditorMandatoryComponentTitle(),
                React.createElement("div", { className: 'coveo-search-interface-mandatory-components' },
                    React.createElement("div", { className: 'CoveoForSitecoreExpressions' }),
                    React.createElement("div", { className: 'CoveoForSitecoreBindWithUserContext' }),
                    React.createElement("div", { className: 'CoveoForSitecoreSyntax' }),
                    React.createElement("div", { className: 'CoveoTriggers' }),
                    React.createElement("div", { className: 'CoveoHiddenQuery' }),
                    this.model.subModels && (React.createElement(React.Fragment, null,
                        React.createElement(AutomaticBoosting_1.AutomaticBoosting, { fields: this.model.subModels.value.automaticBoosting }),
                        React.createElement(SitecoreInstanceFilter_1.SitecoreInstanceFilter, { fields: this.model.subModels.value.sitecoreInstanceFilter }),
                        React.createElement(QueryFilter_1.QueryFilter, { fields: this.model.subModels.value.queryFilter }),
                        React.createElement(QueryRanking_1.QueryRanking, { fields: this.model.subModels.value.queryRanking }),
                        React.createElement(ExternalContent_1.ExternalContent, { fields: this.model.subModels.value.externalContent }))))),
            React.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-content', rendering: this.props.rendering })));
    };
    SearchInterface.prototype.componentWillUnmount = function () {
        var searchInterfaces = document.getElementsByClassName(this.hiveComponentClass);
        if (searchInterfaces && searchInterfaces.length > 0) {
            var searchInterface = searchInterfaces[0];
            if (searchInterface) {
                var historyController = window.Coveo.get(searchInterface, window.Coveo.HistoryController.ID);
                if (historyController && historyController.element) {
                    window.Coveo.$$(historyController.element).trigger(window.Coveo.InitializationEvents.nuke);
                }
            }
        }
    };
    SearchInterface.prototype.render = function () {
        return React.createElement("div", { className: this.isEditingInPageEditor ? 'coveo-page-editor-editing' : '' }, _super.prototype.render.call(this));
    };
    return SearchInterface;
}(CoveoBase_1.CoveoBase));
exports.SearchInterface = SearchInterface;
//# sourceMappingURL=SearchInterface.js.map

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResources = void 0;
var React = __importStar(__webpack_require__(1));
var CoveoJssEvents_1 = __webpack_require__(9);
var CoveoUtils_1 = __webpack_require__(10);
var JssUtils_1 = __webpack_require__(4);
var CoveoBase_1 = __webpack_require__(2);
var react_helmet_1 = __importDefault(__webpack_require__(14));
var package_json_1 = __webpack_require__(31);
var SearchResources = /** @class */ (function (_super) {
    __extends(SearchResources, _super);
    function SearchResources(props) {
        var _this = _super.call(this, props) || this;
        _this.experienceEditorTitle = 'Coveo Search Resources';
        _this.hiveComponentClass = 'CoveoForSitecoreContext';
        _this.initState();
        return _this;
    }
    SearchResources.prototype.initState = function () {
        var searchUiUrlValue = '';
        var coveoForSitecoreSearchUiUrlValue = '';
        if (this.properties.useLocalFiles === true) {
            var resourcesPath = this.properties.resourcesLocalPath
                ? this.properties.resourcesLocalPath
                : '../coveo/hive';
            searchUiUrlValue = resourcesPath;
            coveoForSitecoreSearchUiUrlValue = resourcesPath;
        }
        else {
            var searchUiVersion = package_json_1.dependencies['coveo-search-ui'].split('.', 2).join('.');
            var coveoForSitecoreSearchUiVersion = package_json_1.dependencies['coveoforsitecore-search-ui'];
            var CDN_URL = 'https://static.cloud.coveo.com';
            searchUiUrlValue = CDN_URL + "/searchui/v" + (this.properties.cdnVersion ? this.properties.cdnVersion : searchUiVersion);
            coveoForSitecoreSearchUiUrlValue = CDN_URL + "/coveoforsitecore/ui/v" + coveoForSitecoreSearchUiVersion;
        }
        this.state = {
            searchUiUrl: searchUiUrlValue,
            coveoForSitecoreSearchUiUrl: coveoForSitecoreSearchUiUrlValue,
        };
    };
    SearchResources.prototype.componentDidMount = function () {
        var _this = this;
        var minifiedSuffix = JssUtils_1.JssUtils.isEditingInPageEditor() ? '' : '.min';
        if (!window.Coveo || !window.CoveoForSitecore) {
            var searchUi = document.createElement('script');
            searchUi.src = this.state.searchUiUrl + "/js/CoveoJsSearch.Lazy" + minifiedSuffix + ".js";
            searchUi.async = false;
            searchUi.className = 'coveo-script';
            document.body.appendChild(searchUi);
            var searchUiCultures = document.createElement('script');
            searchUiCultures.src = this.state.searchUiUrl + "/js/cultures/en.js";
            searchUiCultures.async = false;
            document.body.appendChild(searchUiCultures);
            var coveoForSitecoreSearchUi = document.createElement('script');
            coveoForSitecoreSearchUi.src = this.state.coveoForSitecoreSearchUiUrl + "/js/CoveoForSitecore.Lazy" + minifiedSuffix + ".js";
            coveoForSitecoreSearchUi.async = false;
            coveoForSitecoreSearchUi.className = 'coveo-for-sitecore-script';
            if (!JssUtils_1.JssUtils.isServerSideRendering()) {
                coveoForSitecoreSearchUi.addEventListener('load', function () { return _this.configure(); }, { once: true });
            }
            document.body.appendChild(coveoForSitecoreSearchUi);
        }
        else {
            setTimeout(function () {
                CoveoJssEvents_1.CoveoJssEvents.emit(CoveoJssEvents_1.CoveoJssEvents.CoveoResourcesLoaded);
            }, 0);
        }
    };
    SearchResources.prototype.configure = function () {
        var endpointConfiguration = {
            itemUri: this.properties.itemUri,
            siteName: this.properties.siteName,
            restEndpointUri: this.properties.restEndpointUri,
            useLocalFiles: this.properties.useLocalFiles,
            resourcesLocalPath: this.properties.resourcesLocalPath,
            cdnVersion: this.properties.cdnVersion,
        };
        if (CoveoUtils_1.CoveoUtils.isCoveoForSitecoreDefined()) {
            window.CoveoForSitecore.SearchEndpoint.configureSitecoreEndpoint(endpointConfiguration);
            var context = this.reference.current;
            if (!!context) {
                window.CoveoForSitecore.Context.configureContext(context);
            }
        }
        setTimeout(function () {
            CoveoJssEvents_1.CoveoJssEvents.emit(CoveoJssEvents_1.CoveoJssEvents.CoveoResourcesLoaded);
        }, 0);
    };
    SearchResources.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(react_helmet_1.default, null,
                React.createElement("link", { rel: 'stylesheet', href: this.state.searchUiUrl + "/css/CoveoFullSearch.css" }),
                React.createElement("link", { rel: 'stylesheet', href: this.state.coveoForSitecoreSearchUiUrl + "/css/CoveoForSitecore.css" }),
                JssUtils_1.JssUtils.isEditingInPageEditor() && (React.createElement("link", { rel: 'stylesheet', href: this.state.coveoForSitecoreSearchUiUrl + "/css/CoveoForSitecoreExperienceEditor.css" }))),
            _super.prototype.render.call(this)));
    };
    return SearchResources;
}(CoveoBase_1.CoveoBase));
exports.SearchResources = SearchResources;
//# sourceMappingURL=SearchResources.js.map

/***/ }),
/* 31 */
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"coveoforsitecore-jss\",\"description\":\"Coveo for Sitecore JSS.\",\"version\":\"0.1.0\",\"types\":\"bin/def/components.d.ts\",\"main\":\"dist/components.js\",\"author\":\"Coveo for Sitecore Team\",\"license\":\"ISC\",\"dependencies\":{\"coveo-search-ui\":\"2.10083.4\",\"coveoforsitecore-search-ui\":\"0.52.10\"},\"peerDependencies\":{\"@sitecore-jss/sitecore-jss-manifest\":\"^12.0.0\",\"@sitecore-jss/sitecore-jss-react\":\"^12.0.0\",\"globalize\":\"0.1.1\",\"react\":\"~16.7.0\",\"react-dom\":\"~16.7.0\"},\"devDependencies\":{\"@babel/register\":\"~7.0.0\",\"@sitecore-jss/sitecore-jss-cli\":\"^12.0.0\",\"@sitecore-jss/sitecore-jss-dev-tools\":\"^12.0.0\",\"@sitecore-jss/sitecore-jss-manifest\":\"^12.0.0\",\"@sitecore-jss/sitecore-jss-react\":\"^12.0.0\",\"@types/node\":\"^12.7.2\",\"@types/react\":\"^16.9.2\",\"@types/react-dom\":\"^16.9.0\",\"@types/react-redux\":\"^6.0.7\",\"@types/react-router\":\"^4.0.30\",\"@types/react-tether\":\"0.5.3\",\"@types/react-transition-group\":\"2.0.7\",\"@types/redux\":\"^3.6.31\",\"axios\":\"^0.18.1\",\"babel-loader\":\"8.0.4\",\"babel-preset-react-app\":\"~7.0.0\",\"chalk\":\"~2.4.2\",\"chokidar\":\"~2.0.4\",\"cross-env\":\"~5.2.0\",\"gulp\":\"^4.0.2\",\"html-loader\":\"~0.5.5\",\"http-proxy-middleware\":\"~0.19.1\",\"husky\":\"^4.3.8\",\"lint-staged\":\"^10.5.4\",\"npm-run-all\":\"~4.1.5\",\"null-loader\":\"~0.1.1\",\"prettier\":\"^2.2.1\",\"react\":\"~16.7.0\",\"react-dom\":\"~16.7.0\",\"react-helmet\":\"~5.2.0\",\"react-router-dom\":\"~4.3.1\",\"react-scripts\":\"^3.4.1\",\"semver-max\":\"1.0.0\",\"typescript\":\"^3.9.5\",\"url-loader\":\"~1.1.2\",\"webpack\":\"^4.44.1\",\"webpack-cli\":\"^3.3.12\",\"webpack-node-externals\":\"^1.7.2\"},\"scripts\":{\"jss\":\"jss\",\"scaffold\":\"node scripts/scaffold-component.js\",\"webpack\":\"tsc && cross-env-shell NODE_ENV=production \\\"webpack --config webpack.config.js\\\"\",\"prettier\":\"prettier --write \\\"**/*.{js,ts,tsx,css,scss,yaml,json}\\\"\",\"prettier:check\":\"prettier --check \\\"**/*.{js,ts,tsx,css,scss,yaml,json}\\\"\"},\"files\":[\"dist\"],\"husky\":{\"hooks\":{\"pre-commit\":\"lint-staged\"}},\"lint-staged\":{\"*.{js,ts,tsx,css,scss,yaml,json}\":\"prettier --write\"}}");

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostedSearchPage = void 0;
var react_1 = __importDefault(__webpack_require__(1));
var react_helmet_1 = __importDefault(__webpack_require__(14));
var CoveoBase_1 = __webpack_require__(2);
var JssUtils_1 = __webpack_require__(4);
var PlaceholderMessage_1 = __importDefault(__webpack_require__(33));
var ExperienceEditorErrorMessage_1 = __importDefault(__webpack_require__(34));
var ErrorMessage_1 = __importDefault(__webpack_require__(35));
var HostedSearchPage = /** @class */ (function (_super) {
    __extends(HostedSearchPage, _super);
    function HostedSearchPage(props) {
        var _this = _super.call(this, props) || this;
        _this.UNABLE_TO_RETRIEVE_ACCESS_TOKEN = 'Unable to retrieve access token.';
        _this.HOSTED_SEARCH_PAGE_HTML_NOT_FOUND = 'The Hosted Search Page HTML was not found in the page.';
        _this.COVEO_SEARCH_UI_NOT_FOUND = 'Coveo Search UI library was not found.';
        _this.DISCONNECTED_MODE_ERROR_MESSAGE = 'This component only works in connected mode. Please switch to connected mode to preview your page.';
        _this.GENERIC_ERROR_MESSAGE = 'If the problem persists contact the administrator.';
        _this.state = {
            error: _this.properties.errorMessage,
            scriptsLoaded: 0,
        };
        _this.properties.isConnectedToSitecore = !!_this.properties.searchEndpointUri;
        _this.initialize = _this.initialize.bind(_this);
        _this.getAccessToken = _this.getAccessToken.bind(_this);
        return _this;
    }
    HostedSearchPage.prototype.componentDidMount = function () {
        if (this.properties.isConnectedToSitecore) {
            this.addScriptFiles();
            this.addInlineScripts();
        }
    };
    HostedSearchPage.prototype.addScriptFiles = function () {
        var _this = this;
        if (this.properties.searchPageScripts) {
            this.properties.searchPageScripts.forEach(function (url) {
                var element = document.createElement('script');
                element.src = url;
                element.async = false;
                element.addEventListener('load', function () {
                    _this.setState({
                        scriptsLoaded: _this.state.scriptsLoaded + 1,
                    });
                    _this.initialize();
                }, { once: true });
                document.body.appendChild(element);
            });
        }
    };
    HostedSearchPage.prototype.addInlineScripts = function () {
        if (this.properties.searchPageInlineScripts) {
            var element_1 = document.createElement('script');
            this.properties.searchPageInlineScripts.forEach(function (script) {
                element_1.insertAdjacentHTML('beforeend', script);
            });
            document.body.appendChild(element_1);
        }
    };
    HostedSearchPage.prototype.initialize = function () {
        var _this = this;
        if (this.state.scriptsLoaded === this.properties.searchPageScripts.length) {
            this.getAccessToken()
                .then(function (accessToken) {
                _this.initializeCoveo(accessToken);
            })
                .catch(function (err) {
                _this.setState({
                    error: err.message,
                });
            });
        }
    };
    HostedSearchPage.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetchAccessToken()
                        .then(function (response) {
                        if (response.ok) {
                            return response.json();
                        }
                        throw Error(_this.UNABLE_TO_RETRIEVE_ACCESS_TOKEN);
                    })
                        .then(function (data) { return data.token; })
                        .catch(function (err) {
                        _this.setState({
                            error: err.message,
                        });
                        return '';
                    })];
            });
        });
    };
    HostedSearchPage.prototype.initializeCoveo = function (accessToken) {
        var searchPageRoot = document.querySelector('.CoveoSearchInterface');
        if (!searchPageRoot) {
            this.setState({
                error: this.HOSTED_SEARCH_PAGE_HTML_NOT_FOUND,
            });
        }
        else if (typeof Coveo === 'undefined') {
            this.setState({
                error: this.COVEO_SEARCH_UI_NOT_FOUND,
            });
        }
        else {
            Coveo.SearchEndpoint.endpoints['default'] = new Coveo.SearchEndpoint({
                restUri: this.properties.searchEndpointUri + "/rest/search/",
                accessToken: accessToken,
                queryStringArguments: {
                    organizationId: this.properties.organizationId,
                },
                renewAccessToken: this.getAccessToken,
            });
            Coveo.Analytics.options.searchHub['defaultValue'] = this.properties.searchHub;
            Coveo.Analytics.options.organization['defaultValue'] = this.properties.organizationId;
            Coveo.init(searchPageRoot);
        }
    };
    HostedSearchPage.prototype.fetchAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("/coveo/rest/token")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HostedSearchPage.prototype.render = function () {
        if (!this.properties.isConnectedToSitecore) {
            return (react_1.default.createElement(PlaceholderMessage_1.default, null,
                react_1.default.createElement("p", null,
                    this.properties.searchPageId,
                    " hosted search page."),
                react_1.default.createElement("p", null, this.DISCONNECTED_MODE_ERROR_MESSAGE)));
        }
        if (this.state.error) {
            if (JssUtils_1.JssUtils.isEditingInPageEditor()) {
                return react_1.default.createElement(ExperienceEditorErrorMessage_1.default, { message: this.state.error });
            }
            return react_1.default.createElement(ErrorMessage_1.default, { message: this.GENERIC_ERROR_MESSAGE });
        }
        return (react_1.default.createElement("div", { className: 'hostedSearchPage' },
            react_1.default.createElement(react_helmet_1.default, null,
                this.properties.searchPageStyles &&
                    this.properties.searchPageStyles.map(function (style) { return react_1.default.createElement("link", { rel: 'stylesheet', href: "" + style }); }),
                this.properties.searchPageInlineStyles && this.properties.searchPageInlineStyles.length > 0 && (react_1.default.createElement("style", { type: 'text/css' }, " " + this.properties.searchPageInlineStyles.join(' ') + " "))),
            this.properties.searchPageHtml && (react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.properties.searchPageHtml } }))));
    };
    return HostedSearchPage;
}(CoveoBase_1.CoveoBase));
exports.HostedSearchPage = HostedSearchPage;
//# sourceMappingURL=HostedSearchPage.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(1));
var PlaceholderMessage = function (_a) {
    var children = _a.children;
    var messageStyles = {
        margin: 10,
        padding: 30,
        fontSize: 24,
        fontFamily: 'Lato, Helvetica, Arial, sans-serif',
        backgroundColor: '#f1f3f4',
        border: '1px solid #1d4f76',
        borderRadius: 2,
        textAlign: 'center',
    };
    return react_1.default.createElement("div", { style: messageStyles }, children);
};
exports.default = PlaceholderMessage;
//# sourceMappingURL=PlaceholderMessage.js.map

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(1));
var ExperienceEditorErrorMessage = function (_a) {
    var message = _a.message;
    var errorStyles = {
        color: 'red',
        fontWeight: 700,
        fontSize: 14,
    };
    return react_1.default.createElement("span", { style: errorStyles }, message);
};
exports.default = ExperienceEditorErrorMessage;
//# sourceMappingURL=ExperienceEditorErrorMessage.js.map

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(1));
var ErrorMessage = function (_a) {
    var message = _a.message;
    var errorStyles = {
        padding: 45,
        fontSize: 12,
        fontFamily: 'Lato, Helvetica, Arial, sans-serif',
        backgroundColor: '#f1f3f4',
        border: '1px solid #1d4f76',
        textAlign: 'center',
    };
    var messageStyles = {
        marginBottom: 20,
        fontWeight: 400,
    };
    var titleStyles = __assign(__assign({}, messageStyles), { fontSize: 24 });
    var subtitleStyles = __assign(__assign({}, messageStyles), { fontSize: 20 });
    return (react_1.default.createElement("div", { style: errorStyles },
        react_1.default.createElement("h1", { style: titleStyles }, "Something went wrong."),
        react_1.default.createElement("h2", { style: subtitleStyles }, message)));
};
exports.default = ErrorMessage;
//# sourceMappingURL=ErrorMessage.js.map

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalComponentsSection = void 0;
var sitecore_jss_react_1 = __webpack_require__(3);
var React = __importStar(__webpack_require__(1));
var CoveoBase_1 = __webpack_require__(2);
var JssUtils_1 = __webpack_require__(4);
var ExternalComponentsSection = /** @class */ (function (_super) {
    __extends(ExternalComponentsSection, _super);
    function ExternalComponentsSection(props) {
        var _this = _super.call(this, props) || this;
        _this.retry = 10;
        _this.retryTimeout = 200;
        if (!JssUtils_1.JssUtils.isServerSideRendering()) {
            setTimeout(function () { return _this.initialize(); });
        }
        return _this;
    }
    ExternalComponentsSection.prototype.initialize = function () {
        var _this = this;
        if (window.CoveoForSitecore) {
            if (this.isEditingInPageEditor) {
                window.CoveoForSitecore.initExternalComponentsSectionForExperienceEditor(this.reference.current);
            }
            else {
                window.CoveoForSitecore.initExternalComponentsSection(this.reference.current);
            }
        }
        else {
            if (this.retry-- > 0) {
                setTimeout(function () { return _this.initialize(); }, this.retryTimeout);
            }
        }
    };
    ExternalComponentsSection.prototype.renderChildren = function () {
        var rendering = this.props.rendering;
        return React.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-external-components', rendering: rendering });
    };
    return ExternalComponentsSection;
}(CoveoBase_1.CoveoBase));
exports.ExternalComponentsSection = ExternalComponentsSection;
//# sourceMappingURL=ExternalComponentsSection.js.map

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacetsSection = void 0;
var sitecore_jss_react_1 = __webpack_require__(3);
var react_1 = __importStar(__webpack_require__(1));
var FacetsSection = /** @class */ (function (_super) {
    __extends(FacetsSection, _super);
    function FacetsSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FacetsSection.prototype.render = function () {
        var rendering = this.props.rendering;
        return (react_1.default.createElement("div", { className: 'coveo-facet-column', "data-e2e-id": 'coveo-facetsection' },
            react_1.default.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-facets', rendering: rendering })));
    };
    return FacetsSection;
}(react_1.Component));
exports.FacetsSection = FacetsSection;
//# sourceMappingURL=FacetsSection.js.map

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalSearchSection = void 0;
var sitecore_jss_react_1 = __webpack_require__(3);
var react_1 = __importStar(__webpack_require__(1));
var GlobalSearchSection = /** @class */ (function (_super) {
    __extends(GlobalSearchSection, _super);
    function GlobalSearchSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalSearchSection.prototype.render = function () {
        var rendering = this.props.rendering;
        return (react_1.default.createElement("div", { className: 'coveo-search-section', "data-e2e-id": 'coveo-globalsearchsection' },
            react_1.default.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-global-searchbox', rendering: rendering })));
    };
    return GlobalSearchSection;
}(react_1.Component));
exports.GlobalSearchSection = GlobalSearchSection;
//# sourceMappingURL=GlobalSearchSection.js.map

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultsHeaderSection = void 0;
var sitecore_jss_react_1 = __webpack_require__(3);
var react_1 = __importDefault(__webpack_require__(1));
exports.ResultsHeaderSection = function (_a) {
    var rendering = _a.rendering;
    return (react_1.default.createElement("div", { className: 'coveo-results-header', "data-e2e-id": 'coveo-resultsheadersection' },
        react_1.default.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-results-header-section', rendering: rendering })));
};
//# sourceMappingURL=ResultsHeaderSection.js.map

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultsSection = void 0;
var sitecore_jss_react_1 = __webpack_require__(3);
var react_1 = __importDefault(__webpack_require__(1));
exports.ResultsSection = function (_a) {
    var rendering = _a.rendering;
    return (react_1.default.createElement("div", { className: 'coveo-results-column', "data-e2e-id": 'coveo-resultssection' },
        react_1.default.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-results-header', rendering: rendering }),
        react_1.default.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-results', rendering: rendering }),
        react_1.default.createElement("div", { className: 'CoveoLogo' }),
        react_1.default.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-results-footer-components', rendering: rendering })));
};
//# sourceMappingURL=ResultsSection.js.map

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultsSortsSection = void 0;
var sitecore_jss_react_1 = __webpack_require__(3);
var react_1 = __importDefault(__webpack_require__(1));
exports.ResultsSortsSection = function (_a) {
    var rendering = _a.rendering;
    return (react_1.default.createElement("div", { className: 'coveo-sort-section', "data-e2e-id": 'coveo-resultssortsection' },
        react_1.default.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-sorts', rendering: rendering })));
};
//# sourceMappingURL=ResultsSortsSection.js.map

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultsSummarySection = void 0;
var sitecore_jss_react_1 = __webpack_require__(3);
var react_1 = __importStar(__webpack_require__(1));
var ResultsSummarySection = /** @class */ (function (_super) {
    __extends(ResultsSummarySection, _super);
    function ResultsSummarySection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResultsSummarySection.prototype.render = function () {
        var rendering = this.props.rendering;
        return (react_1.default.createElement("div", { className: 'coveo-summary-section', "data-e2e-id": 'coveo-resultssummarysection' },
            react_1.default.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-results-summary-section', rendering: rendering })));
    };
    return ResultsSummarySection;
}(react_1.Component));
exports.ResultsSummarySection = ResultsSummarySection;
//# sourceMappingURL=ResultsSummarySection.js.map

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchSection = void 0;
var sitecore_jss_react_1 = __webpack_require__(3);
var react_1 = __importStar(__webpack_require__(1));
var JssUtils_1 = __webpack_require__(4);
var SearchSection = /** @class */ (function (_super) {
    __extends(SearchSection, _super);
    function SearchSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchSection.prototype.renderExperienceEditorContent = function () {
        if (JssUtils_1.JssUtils.isEditingInPageEditor()) {
            return (react_1.default.createElement("div", { className: 'coveo-settings-components-help' }, "Add options for the Settings button in this placeholder."));
        }
    };
    SearchSection.prototype.render = function () {
        var rendering = this.props.rendering;
        return (react_1.default.createElement("div", { className: 'coveo-search-section', "data-e2e-id": 'coveo-searchsection' },
            react_1.default.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-searchbox', rendering: rendering }),
            react_1.default.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-searchbox-settings', rendering: rendering }),
            react_1.default.createElement("div", { className: 'coveo-hide-until-settings-added' },
                react_1.default.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-searchbox-options', rendering: rendering }),
                this.renderExperienceEditorContent())));
    };
    return SearchSection;
}(react_1.Component));
exports.SearchSection = SearchSection;
//# sourceMappingURL=SearchSection.js.map

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsSection = void 0;
var sitecore_jss_react_1 = __webpack_require__(3);
var react_1 = __importStar(__webpack_require__(1));
var TabsSection = /** @class */ (function (_super) {
    __extends(TabsSection, _super);
    function TabsSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabsSection.prototype.render = function () {
        var rendering = this.props.rendering;
        return (react_1.default.createElement("div", { className: 'coveo-tab-section coveo-placeholder-fix' },
            react_1.default.createElement(sitecore_jss_react_1.Placeholder, { name: 'jss-coveo-ui-tabs-section', rendering: rendering })));
    };
    return TabsSection;
}(react_1.Component));
exports.TabsSection = TabsSection;
//# sourceMappingURL=TabsSection.js.map

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sort = void 0;
var react_1 = __importDefault(__webpack_require__(1));
var CoveoBase_1 = __webpack_require__(2);
var Sort = /** @class */ (function (_super) {
    __extends(Sort, _super);
    function Sort(props) {
        var _this = _super.call(this, props) || this;
        _this.tagName = 'span';
        return _this;
    }
    Sort.prototype.render = function () {
        return react_1.default.createElement("div", { className: 'coveo-sort-container' }, _super.prototype.render.call(this));
    };
    return Sort;
}(CoveoBase_1.CoveoBase));
exports.Sort = Sort;
//# sourceMappingURL=Sort.js.map

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
var react_1 = __importDefault(__webpack_require__(1));
var CoveoBase_1 = __webpack_require__(2);
var QueryFilter_1 = __webpack_require__(7);
var QueryRanking_1 = __webpack_require__(8);
var ExternalContent_1 = __webpack_require__(6);
var Tab = /** @class */ (function (_super) {
    __extends(Tab, _super);
    function Tab(props) {
        var _this = _super.call(this, props) || this;
        _this.hiveComponentClass = 'CoveoTab';
        _this.tagName = 'a';
        return _this;
    }
    Tab.prototype.renderChildren = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: 'coveo-tab-component-container' }, this.model.subModels && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(QueryFilter_1.QueryFilter, { fields: this.withScopeToTab(this.model.subModels.value.queryFilter) }),
                react_1.default.createElement(QueryRanking_1.QueryRanking, { fields: this.withScopeToTab(this.model.subModels.value.queryRanking) }),
                react_1.default.createElement(ExternalContent_1.ExternalContent, { fields: this.withScopeToTab(this.model.subModels.value.externalContent) }))))));
    };
    Tab.prototype.withScopeToTab = function (properties) {
        var _a;
        return __assign(__assign({}, properties), (_a = {}, _a["scopeToTab"] = { value: this.id }, _a['hasScopeToTab'] = { value: true }, _a['id'] = null, _a));
    };
    return Tab;
}(CoveoBase_1.CoveoBase));
exports.Tab = Tab;
//# sourceMappingURL=Tab.js.map

/***/ })
/******/ ]);
});